import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * The appointment days to display, each with its bookable slots, in the same shape `sp-slot-cards`
   * takes. Object data has no attribute form, so set it as a DOM property (`:entries.prop` in a
   * template, `el.entries = …` in script); a JSON string is accepted for markup that can only pass
   * attributes.
   *
   * Each entry is `{ date, slots: [{ start_time, booking_url, visit_type_categories_description,
   * visit_type_categories }] }`. A slot listing `video` in `visit_type_categories` gets the video icon.
   *
   * @type {Array|String}
   * @default []
   */
  entries: {
    type: [Array, String],
    default: () => [],
  },
  /**
   * Number of times a day lists before the rest collapse into an "N more" button. Days with fewer
   * times are padded with fillers so every day has the same number of cells.
   *
   * @type {Number}
   * @storybook-control number
   * @default 3
   */
  maxSlots: {
    type: Number,
    default: 3,
  },
  /**
   * Widest viewport, in px, at which the days stack one under another. A narrower viewport stacks
   * them; a wider one sets them side by side.
   *
   * @type {Number}
   * @storybook-control number
   * @default 750
   */
  rowsMaxViewportWidth: {
    type: Number,
    default: 750,
  },
  /**
   * Narrowest viewport, in px, at which each day lists its times in a column and hides its heading.
   * Below it a day lists its times in a row that scrolls sideways. A client whose finder breakpoint
   * differs sets its own value as a deployment default.
   *
   * @type {Number}
   * @storybook-control number
   * @default 751
   */
  columnsMinViewportWidth: {
    type: Number,
    default: 751,
  },
  /**
   * When a day heading states the year: "never", "next_year" (any year but the current one) or
   * "always".
   *
   * @type {String}
   * @default "never"
   */
  showYear: {
    type: String,
    default: "never",
    validator: (value) => ["never", "next_year", "always"].includes(value),
  },
  /**
   * Leave out the Full Schedule button.
   *
   * @type {Boolean|String}
   * @default false
   */
  noFullSchedule: booleanAttribute(),
  /**
   * `sp-icon` name inside the Full Schedule button.
   *
   * @type {String}
   * @default "event-filled"
   */
  fullScheduleIcon: {
    type: String,
    default: "event-filled",
  },
});
